export default __webpack_public_path__ + "static/media/image-work-company-w.292c277c.png";